
export class FocusState {
    constructor() {
        this.index = 0;
        this.items = [];
        this.area = null;
        this.selectedIndex = null;
    }

    getSelectedIndex() {
        return this.selectedIndex === null ? -1 : this.selectedIndex;
    }

    setSelectedIndex(index) {
        this.selectedIndex = index;
    }

    getItemAtIndex(i) {
        return this.items[i];
    }

    getItemCount() {
        return this.items.length;
    }

    getScrollableArea() {
        return this.area;
    }

    addItem(isSelected) {
        const currentIndex = this.index;
        this.index++;

        if (isSelected && this.selectedIndex === null) {
            this.selectedIndex = currentIndex;
        }

        return item => {
            this.items[currentIndex] = item;
        };
    }

    setScrollableArea(area) {
        this.area = area;
    }
}
